import { useEffect, useLayoutEffect, useRef } from "react";

export function useEventListener<K extends keyof WindowEventMap>(
  type: K,
  listener: (event: WindowEventMap[K]) => void,
  options?: boolean | AddEventListenerOptions
) {
  const listenerRef = useRef(listener);
  useLayoutEffect(() => {
    listenerRef.current = listener;
  }, [listener]);

  useEffect(() => {
    const listenerProxy: typeof listener = (event) => {
      listenerRef.current(event);
    };
    addEventListener(type, listenerProxy, options);
    return () => removeEventListener(type, listenerProxy, options);
  }, [type, options]);
}
